var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonWithSp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.38,
    height: 253.831,
    viewBox: "0 0 173.38 253.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-366.581 -3413.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.671 3411.164)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.69,
    cy: 86.69,
    r: 86.69,
    transform: "translate(159.91 82.806)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.566,83.993a80.469,80.469,0,1,0,80.469,80.469,80.469,80.469,0,0,0-80.469-80.469Zm-21.515,25.154c3.856.059,6.683,1.366,7.88,3.644,2.542,4.837-2.8,12.649-11.939,17.45s-18.6,4.772-21.144-.066,2.8-12.648,11.939-17.449a28.822,28.822,0,0,1,13.263-3.579Zm50.034,6.516c3.606,0,6.53,2.088,6.532,4.664a3.422,3.422,0,0,1-.206,1.14c5.6.727,9.528,3.334,9.537,6.326,0,3.607-5.64,6.532-12.6,6.532s-12.6-2.925-12.6-6.532c.005-1.809,1.457-3.536,4.009-4.769a3.842,3.842,0,0,1-1.21-2.7c0-2.577,2.927-4.665,6.535-4.664Zm-37.176,41.474c4.3,0,7.78,1.858,7.777,4.15s-3.481,4.147-7.776,4.147-7.775-1.856-7.776-4.147,3.478-4.15,7.775-4.15Zm39.271,18.927a24.333,24.333,0,0,1,10.712,2.823c7.656,3.882,12.2,10.315,10.143,14.369s-9.928,4.193-17.585.311-12.2-10.314-10.143-14.368c1.007-1.986,3.487-3.116,6.876-3.135Zm-72.889.344a13.626,13.626,0,0,1,13.6,12.826A7.724,7.724,0,1,1,206.2,201.76a13.619,13.619,0,1,1-6.908-25.351Z",
    transform: "translate(5.034 5.034)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.379 273.442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.017, -1, 1, 0.017, 105.501, 3220.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6,0C34.264,0,52.64,6.985,52.64,15.6S34.264,31.2,11.6,31.2,6.479,23.241,6.479,14.625-11.071,0,11.6,0Z",
    transform: "translate(0 0)",
    fill: "#858585",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.935,0C16.974,0,26.8,5.2,26.8,10.926S16.974,22.9,10.935,22.9A11.2,11.2,0,0,1,0,11.452,11.2,11.2,0,0,1,10.935,0Z",
    transform: "translate(23.616 4.27)",
    fill: "#0dcca5",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.391, -0.921, 0.921, 0.391, 146.989, 3224.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.578,0C19.436,0,29.86,3.962,29.86,8.85S19.436,17.7,6.578,17.7s-2.9-4.516-2.9-9.4S-6.28,0,6.578,0Z",
    transform: "translate(0 0)",
    fill: "#858585",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2,0c3.426,0,9,2.95,9,6.2s-5.573,6.794-9,6.794A6.355,6.355,0,0,1,0,6.5,6.355,6.355,0,0,1,6.2,0Z",
    transform: "translate(13.396 2.422)",
    fill: "#0b334b",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.468,9.355s9.921-2.079,11.042.446-7.071,8.494-7.071,8.494,5.043,8.793,2.989,10.64-10.263-4.1-10.263-4.1-6.8,7.513-9.2,6.13S8.7,19.938,8.7,19.938-.551,15.788.026,13.086s10.713-2.715,10.713-2.715S11.828.293,14.575.006,20.468,9.355,20.468,9.355Z",
    transform: "translate(69.67 3159.442) rotate(-30)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.961,2.724s2.889-.605,3.216.13S7.117,5.328,7.117,5.328s1.469,2.561.87,3.1S5,7.232,5,7.232,3.017,9.42,2.321,9.017s.212-3.211.212-3.211S-.16,4.6.008,3.811s3.12-.791,3.12-.791S3.444.085,4.244,0,5.961,2.724,5.961,2.724Z",
    transform: "matrix(-0.799, -0.602, 0.602, -0.799, 137.258, 3152.859)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.756,1.717s1.82-.381,2.026.082-1.3,1.559-1.3,1.559.925,1.613.548,1.952S3.15,4.557,3.15,4.557,1.9,5.936,1.462,5.682,1.6,3.658,1.6,3.658-.1,2.9,0,2.4s1.966-.5,1.966-.5.2-1.849.7-1.9S3.756,1.717,3.756,1.717Z",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 137.473, 3173.935)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,1.63S7.079-.415,7.754.076s-.564,3.29-.564,3.29S9.838,4.9,9.58,5.7s-3.3.48-3.3.48S5.634,9.171,4.8,9.171,3.321,6.177,3.321,6.177.276,6.491.018,5.7s2.391-2.33,2.391-2.33S1.169.567,1.844.076,4.8,1.63,4.8,1.63Z",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 161.791, 3192.606)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.515,3.435s3.642-.763,4.054.164-2.6,3.118-2.6,3.118,1.851,3.228,1.1,3.907S6.3,9.118,6.3,9.118s-2.5,2.758-3.376,2.251.267-4.049.267-4.049S-.2,5.8.01,4.8s3.933-1,3.933-1S4.342.108,5.351,0,7.515,3.435,7.515,3.435Z",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 169.018, 3163.951)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.741,171.278s3.642-.763,4.054.164-2.6,3.118-2.6,3.118,1.851,3.228,1.1,3.907-3.768-1.505-3.768-1.505-2.5,2.758-3.376,2.251.267-4.049.267-4.049-3.4-1.524-3.184-2.515,3.933-1,3.933-1,.4-3.7,1.409-3.805S695.741,171.278,695.741,171.278Z",
    transform: "translate(-646.406 3008.479)",
    fill: "#fbb040"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.016 3232.909) rotate(-115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.364,0c16.348,0,29.6,5.038,29.6,11.252S24.711,22.5,8.364,22.5,4.673,16.762,4.673,10.548-7.984,0,8.364,0Z",
    transform: "translate(0 0)",
    fill: "#858585",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.886,0c4.356,0,11.441,3.75,11.441,7.88s-7.086,8.639-11.441,8.639A8.079,8.079,0,0,1,0,8.259,8.079,8.079,0,0,1,7.886,0Z",
    transform: "translate(17.032 3.08)",
    fill: "#fbb040",
    opacity: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonWithSp);
export default __webpack_public_path__ + "static/media/moonWithSP.31e081daa52a7a43e5778961cae0ae1e.svg";
export { ForwardRef as ReactComponent };